import { BehaviorSubject } from 'rxjs';
import { SHOW_LOGS } from 'config';
import { EventProvidersColors, IEventSaveLogger, IEventSaveLoggerlist } from './@types';

class LoggerSaver {
  eventList$ = new BehaviorSubject<IEventSaveLoggerlist[]>([]);

  list: IEventSaveLoggerlist[] = [];

  saveToLogger(event: IEventSaveLogger): void {
    const providers = event.providers.map((item) => ({
      name: item,
      color: EventProvidersColors[item],
    }));
    const time = new Date();

    this.list.push({
      ...event,
      providers,
      date: time,
    });
    this.eventList$.next(this.list);
    if (SHOW_LOGS) {
      console.info(`%cℹ️ Event::${event?.tag}::${time}`, 'background: #006579; color: #c2f5ff; font-size: 12px');
      console.table({
        providers: { ...event.providers },
        params: event?.params || {},
      });
    }
  }

  getEvents = (): BehaviorSubject<IEventSaveLoggerlist[]> => this.eventList$;
}

export default LoggerSaver;
